const now = new Date();

const searchOptions = [
  {
    id: 1,
    periodo: "Hoje",
    startDate: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0), // 00:00 hoje
    endDate: now, // agora
  },
  {
    id: 2,
    periodo: "Ontem",
    startDate: new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 0, 0, 0), // 00:00 ontem
    endDate: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0), // 00:00 hoje
  },
  {
    id: 3,
    periodo: "Últimos 7 dias",
    startDate: new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7, 0, 0, 0), // 00:00 de 7 dias atrás
    endDate: now, // agora
  },
  {
    id: 4,
    periodo: "Este mês",
    startDate: new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0), // 00:00 do dia 1 deste mês
    endDate: now, // agora
  },
  {
    id: 5,
    periodo: "Último mês",
    startDate: new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0), // 00:00 do dia 1 do mês anterior
    endDate: new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0), // 00:00 do dia 1 deste mês
  },
];

export default searchOptions;
